import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";
import mobileCheck from "../common/util/mobileCheck";

import DecorationStoreEquipmentListItem from "./DecorationStoreEquipmentListItem";

export default class DecorationStoreEquipmentListModal extends Modal {
  static isDismissibleViaBackdropClick = false
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    const {itemType,callback} = this.attrs;

    this.loading = true;
    this.moreResults = false;
    this.itemPurchaseHistoryList = [];
    this.filterItemType = Stream(itemType);
    this.filterItemStatus = Stream("-1");
    this.filterItem();
  }

  className() {
    return 'Modal--Medium';
  }

  title() {
    return app.translator.trans('ziven-decoration-store.forum.equipment-modal-title');
  }

  content() {
    let loading;
    let itemCount = 0;
    let itemCheckNumber = mobileCheck()?2:3;

    if(this.loading){
      loading = LoadingIndicator.component({ size: "large" });
    }

    return [
      <div style="padding:10px;" className="Modal-body">
        <div className="DecorationEquipmentListFlexCard">
          {this.itemPurchaseHistoryList.map((itemPurchaseData) => {
            let itemClass = "DecorationEquipmentListCardsListItem DecorationEquipmentListCard";

            if(itemCount%itemCheckNumber!==0){
              itemClass+=" DecorationEquipmentListCardAdjust";
            }

            itemCount++;

            return (
              <div className={itemClass}>
                {DecorationStoreEquipmentListItem.component({ itemPurchaseData })}
              </div>
            );
          })}
        </div>

        {!this.loading && this.itemPurchaseHistoryList.length===0 && (
          <div>
            <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;">{app.translator.trans("ziven-decoration-store.lib.list-empty")}</div>
          </div>
        )}

        {!loading && this.hasMoreResults() && (
          <div style="text-align:center;padding:20px">
            <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
              {app.translator.trans('ziven-decoration-store.lib.list-load-more')}
            </Button>
          </div>
        )}

        {loading && <div className="DecorationStore-loadMore">{loading}</div>}

      </div>,
    ];
  }

  filterItem(){
    this.itemPurchaseHistoryList = [];
    this.loading = true;
    m.redraw();
    this.loadResults();
  }

  loadMore() {
    this.loading = true;
    this.loadResults(this.itemPurchaseHistoryList.length);
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.itemPurchaseHistoryList, results);
    this.loading = false;
    m.redraw();
  }

  hasMoreResults() {
    return this.moreResults;
  }

  loadResults(offset = 0) {
    const filter = {
      item_type:this.filterItemType(),
      item_status:this.filterItemStatus()
    };

    return app.store
      .find("decorationStorePurchaseHistory", {
        filter,
        page: {
          offset,
        },
      })
      .catch(() => {})
      .then(this.parseResults.bind(this));
  }
}